import React from "react";
import { BaseComponent } from "../../base/BaseComponent";
import LogoText from "../../shared/Logo/LogoText";
import ContactUsComponent from "../../contact-us/ContactUs";

export default class OTC extends BaseComponent {
  render() {
    return (
      <>
        <div className="gx-mb-5">
          <h1 className="heading-big">
            <LogoText /> OTC Desk
          </h1>
          <p className="text-medium">{this.lang.OTCIntroPara}</p>
        </div>
        <div className="gx-mb-5">
          <h1>Here is how our OTC process works: </h1>
          <ul className="list-medium list-style">
            <li>Client receives the contract, and KYC is performed.</li>
            <li>
              User sends the deposit to our company account (Euro, USD, GBP and
              BTC accepted).
            </li>
            <li>
              Once funds hit the company accounts, client confirms the intent to
              trade.
            </li>
            <li>
              Price is communicated to user (via f2f or a secure communication).
            </li>
            <li>
              Client provides the wallet address, confirms the price and volume,
              and replies with the text "done".
            </li>
            <li>
              Trade is successfully executed, and funds are credited into user
              wallet or account.
            </li>
            <li>
              For buying BTC, successful confirmation can take between 15
              minutes to hours. It is important to note that in some exceptional
              cases it may take up to 24 hours.
            </li>
            <li>
              For selling, funds would hit user account depending upon location
              and the type of payment used, It could be either instant or take
              up to 5 working days.
            </li>
          </ul>
        </div>
        <ContactUsComponent
          {...this.props}
          params={{
            formHeading:
              "To use our OTC service, fill the form below, and a member of our team will give you a call shortly.",
            type: "OTC_form"
          }}
        />
      </>
    );
  }
}
